import { FC } from 'react';

import CircleCheckIcon from '@/assets/svg/ui-elements/circle-check.svg';
import PlusCircleIcon from '@/assets/svg/ui-elements/plus-circle-outline.svg';
import { theme, Tooltip } from '@/shared/design-system';

export const ANNOTATION_LABEL = {
  existing: 'Already in your address book',
  new: 'New value – will be created',
} as const;

interface FieldAnnotationProps {
  isAlreadyPresent: boolean;
}

export const FieldAnnotation: FC<FieldAnnotationProps> = ({ isAlreadyPresent }) => {
  const label = isAlreadyPresent ? ANNOTATION_LABEL.existing : ANNOTATION_LABEL.new;
  const Icon = isAlreadyPresent ? CircleCheckIcon : PlusCircleIcon;

  return (
    <Tooltip title={label}>
      <span role="img" aria-label={label} style={{ display: 'flex' }}>
        <Icon
          width={16}
          height={16}
          color={isAlreadyPresent ? theme.colors.icon.brand : theme.colors.icon.info}
        />
      </span>
    </Tooltip>
  );
};
